// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ZYaJ7zU flex flex-column md-hide lg-hide items-center p2","header":"_20_V7GjZ mt2","title":"_1-jfj91H"};